var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
// semeia-disable-reexport
import { tracked } from "@glimmer/tracking";

// Types are adapted from http://localhost:10007/swagger-ui.html#/dmpc-controller/.

export let DMPConnectSex = /*#__PURE__*/function (DMPConnectSex) {
  DMPConnectSex[DMPConnectSex["UnknownSex"] = 1] = "UnknownSex";
  DMPConnectSex[DMPConnectSex["Male"] = 2] = "Male";
  DMPConnectSex[DMPConnectSex["Female"] = 3] = "Female";
  return DMPConnectSex;
}({});
var VitaleCardPatientQuality = /*#__PURE__*/function (VitaleCardPatientQuality) {
  VitaleCardPatientQuality[VitaleCardPatientQuality["Assure"] = 0] = "Assure";
  VitaleCardPatientQuality[VitaleCardPatientQuality["Ascendants"] = 1] = "Ascendants";
  VitaleCardPatientQuality[VitaleCardPatientQuality["Conjoint"] = 2] = "Conjoint";
  VitaleCardPatientQuality[VitaleCardPatientQuality["ConjointDivorce"] = 3] = "ConjointDivorce";
  VitaleCardPatientQuality[VitaleCardPatientQuality["Concubin"] = 4] = "Concubin";
  VitaleCardPatientQuality[VitaleCardPatientQuality["ConjointSepare"] = 5] = "ConjointSepare";
  VitaleCardPatientQuality[VitaleCardPatientQuality["Enfant"] = 6] = "Enfant";
  VitaleCardPatientQuality[VitaleCardPatientQuality["ConjointVeuf"] = 8] = "ConjointVeuf";
  VitaleCardPatientQuality[VitaleCardPatientQuality["Autre"] = 9] = "Autre";
  return VitaleCardPatientQuality;
}(VitaleCardPatientQuality || {});
export let DmpConnectJSInsIdentityResultCode = /*#__PURE__*/function (DmpConnectJSInsIdentityResultCode) {
  DmpConnectJSInsIdentityResultCode[DmpConnectJSInsIdentityResultCode["InsIdentityResult_NoIdentityFound"] = 1] = "InsIdentityResult_NoIdentityFound";
  DmpConnectJSInsIdentityResultCode[DmpConnectJSInsIdentityResultCode["InsIdentityResult_SingleIdentityFound"] = 2] = "InsIdentityResult_SingleIdentityFound";
  DmpConnectJSInsIdentityResultCode[DmpConnectJSInsIdentityResultCode["InsIdentityResult_MultipleIdentitiesFound"] = 3] = "InsIdentityResult_MultipleIdentitiesFound";
  return DmpConnectJSInsIdentityResultCode;
}({});
export let DmpAuthorizationStatus = /*#__PURE__*/function (DmpAuthorizationStatus) {
  DmpAuthorizationStatus["Authorized"] = "AUTHORIZED";
  DmpAuthorizationStatus["Expired"] = "EXPIRED";
  DmpAuthorizationStatus["NotAuthorized"] = "NOT_AUTHORIZED";
  return DmpAuthorizationStatus;
}({});
export let DocumentStatus = /*#__PURE__*/function (DocumentStatus) {
  DocumentStatus["APPROVED"] = "APPROVED";
  DocumentStatus["DEPRECATED"] = "DEPRECATED";
  DocumentStatus["SUBMITTED"] = "SUBMITTED";
  DocumentStatus["ARCHIVED"] = "ARCHIVED";
  DocumentStatus["DELETED"] = "DELETED";
  return DocumentStatus;
}({});
export let DocumentVisibility = /*#__PURE__*/function (DocumentVisibility) {
  DocumentVisibility["NORMAL"] = "N";
  DocumentVisibility["HIDDEN_TO_PATIENT"] = "HIDDEN_TO_PATIENT";
  DocumentVisibility["HIDDEN_TO_HEALTHCARE_PROFESSIONAL"] = "HIDDEN_TO_HEALTHCARE_PROFESSIONAL";
  DocumentVisibility["HIDDEN_TO_LEGAL_REPRESENTATIVES"] = "HIDDEN_TO_LEGAL_REPRESENTATIVES";
  return DocumentVisibility;
}({});
export let InsOid = /*#__PURE__*/function (InsOid) {
  InsOid["NIR"] = "1.2.250.1.213.1.4.8";
  InsOid["NIA"] = "1.2.250.1.213.1.4.9";
  InsOid["TEST"] = "1.2.250.1.213.1.4.10";
  InsOid["DEMO"] = "1.2.250.1.213.1.4.11";
  InsOid["UNKNOWN"] = "unknown";
  return InsOid;
}({});
export let InsType = /*#__PURE__*/function (InsType) {
  InsType["NIA"] = "NIA";
  InsType["NIR"] = "NIR";
  InsType["UNKNOWN"] = "NIR ou NIA";
  return InsType;
}({});
export let InsSex = /*#__PURE__*/function (InsSex) {
  InsSex[InsSex["Unknown"] = 1] = "Unknown";
  InsSex[InsSex["Male"] = 2] = "Male";
  InsSex[InsSex["Female"] = 3] = "Female";
  return InsSex;
}({});
export let InsIdentityResultCode = /*#__PURE__*/function (InsIdentityResultCode) {
  InsIdentityResultCode["InsIdentityResult_NoIdentityFound"] = "01";
  InsIdentityResultCode["InsIdentityResult_SingleIdentityFound"] = "00";
  InsIdentityResultCode["InsIdentityResult_MultipleIdentitiesFound"] = "02";
  return InsIdentityResultCode;
}({});
export let InsStatus = /*#__PURE__*/function (InsStatus) {
  InsStatus["Provisional"] = "provisional";
  InsStatus["Validated"] = "validated";
  InsStatus["Recovered"] = "recovered";
  InsStatus["Qualified"] = "qualified";
  return InsStatus;
}({});
export let InsIdentityDocumentType = /*#__PURE__*/function (InsIdentityDocumentType) {
  InsIdentityDocumentType["Passport"] = "passport";
  InsIdentityDocumentType["IdCard"] = "idCard";
  InsIdentityDocumentType["BirthAct"] = "birthAct";
  InsIdentityDocumentType["ResidencePermit"] = "residencePermit";
  InsIdentityDocumentType["DigitalDevice"] = "digitalDevice";
  InsIdentityDocumentType["Other"] = "other";
  InsIdentityDocumentType["Nothing"] = "nothing";
  return InsIdentityDocumentType;
}({});
export let DmpDocumentsSearchParams = (_class = class DmpDocumentsSearchParams {
  constructor(typeCodes, serviceStartTimeFrom, serviceStopTimeTo, submissionStartTimeFrom, archived, obsolete, hiddenToPatient, hiddenToHealthcareProfessional, hiddenToLegalRepresentatives) {
    _initializerDefineProperty(this, "submissionStartTimeFrom", _descriptor, this);
    this.typeCodes = typeCodes;
    this.serviceStartTimeFrom = serviceStartTimeFrom;
    this.serviceStopTimeTo = serviceStopTimeTo;
    this.archived = archived;
    this.obsolete = obsolete;
    this.hiddenToPatient = hiddenToPatient;
    this.hiddenToHealthcareProfessional = hiddenToHealthcareProfessional;
    this.hiddenToLegalRepresentatives = hiddenToLegalRepresentatives;
    this.submissionStartTimeFrom = submissionStartTimeFrom;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "submissionStartTimeFrom", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);